import * as Yup from 'yup';


export const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  country: Yup.string().required(),
  redirectUrl: Yup.string().required().url(),
});

export const formsInputsData = [
  {
    id: 'name',
    title: 'BRAND.FORMS_INPUTS.NAME',
    type: 'text',
    iconName: 'user',
  },
  {
    id: 'country',
    title: 'BRAND.FORMS_INPUTS.COUNTRY',
    type: 'select',
    options: [
      { value: 'CL', label: 'CL' },
      { value: 'PE', label: 'PE' },
      { value: 'MX', label: 'MX' },
      { value: 'CO', label: 'CO' },
    ],
    iconName: 'location-pin',
  },
  {
    id: 'redirectUrl',
    title: 'BRAND.FORMS_INPUTS.REDIRECT_URL',
    type: 'url',
    iconName: 'url',
  },
];

export const initialValues = {
  name: '',
  country: '',
  redirectUrl: '',
};
